import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

const difference = (startDate, endDate) => {
  return dayjs.duration(dayjs(endDate).diff(startDate))
}

export const formatDifference = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return ''
  }

  const diff = difference(startDate, endDate)

  const hours = Math.floor(diff.asHours())

  return `${hours}:${diff.format('mm:ss')}`
}

export const formatDifferenceFromNow = (date) => {
  return formatDifference(date, new Date())
}
